import { CheckmarkCircleIcon, InfoOutlineIcon } from '@carboncopyco/icons';
import type { Dimension } from '@carboncopyco/types';
import {
  ColorHex,
  TextButton,
  TextCaption,
  Tooltip,
  TooltipMessage,
} from '@carboncopyco/ui';
import classNames from 'classnames';
import { type MouseEventHandler, useRef } from 'react';

type DimensionCardProps = {
  label: string;
  imageComponent: React.ReactElement;
  onSelect: MouseEventHandler;
  resolution: Dimension;
  hint?: string;
  isSelected?: boolean;
};

const DimensionCard = ({
  label,
  hint = '',
  imageComponent,
  onSelect,
  resolution,
  isSelected = false,
}: DimensionCardProps) => {
  const hintRef = useRef();
  const cardRef = useRef();

  const mapLabelColor = () => {
    if (isSelected) {
      return 'text-ds-primary-300';
    }

    return 'text-ds-natural-600';
  };

  return (
    <>
      <div
        ref={cardRef}
        className={`flex flex-row justify-left items-center mb-2 w-full px-3 
         border border-solid rounded-lg cursor-pointer ${classNames({
           'border-ds-primary-300 ': isSelected,
           'border-ds-natural-150 hover:border-ds-natural-300': !isSelected,
         })}`}
        onClick={(event) => {
          onSelect(event);
        }}
      >
        <div>{imageComponent}</div>
        <div className="flex flex-col mx-1 w-[77px]">
          <div className="flex flex-row justify-left items-center text-ds-natural-600">
            <TextButton
              label={label}
              color={mapLabelColor()}
            />
            {hint && (
              <div
                className="mx-1"
                ref={hintRef}
              >
                <InfoOutlineIcon
                  size="15px"
                  color={ColorHex.natural300}
                />
              </div>
            )}
          </div>
          {resolution && (
            <TextCaption
              label={`${resolution.width}x${resolution.height}px`}
              color={'text-ds-natural-300'}
            />
          )}
        </div>
        <div className="ml-6">
          {isSelected ? (
            <CheckmarkCircleIcon
              color={ColorHex.primary300}
              size={'19px'}
            />
          ) : (
            <div
              className={classNames(
                'rounded-lg border border-solid border-ds-natural-200 w-[16px] h-[16px]'
              )}
            />
          )}
        </div>
        {hint && (
          <Tooltip
            shadow="md"
            noArrow
            placement="top-end"
            anchorRef={hintRef}
            interactiveBorder={0}
            fixedWidth={true}
          >
            <div className="w-[219px] h-[88px]">
              <TooltipMessage
                title={hint}
                titleColor="text-ds-natural-300"
              />
            </div>
          </Tooltip>
        )}
      </div>
    </>
  );
};

export default DimensionCard;
